import {InterestCategory} from 'shared/types'

export type InterestsModalProps = {
    canSkip?: boolean
  }

export const convertToIdArray = (categories: InterestCategory[]): number[] =>
  categories
    .map((category) => category.interests.map((interest) => interest.id))
    .flat()

export const convertToDataArray = (idList: number[], sourceArray: InterestCategory[]): InterestCategory[] =>
  idList.reduce((prev, id) => {
    const matchingItem = sourceArray.find((item) => item.interests.some((interest) => interest.id === id))

    if (matchingItem) {
      const existingItem = prev.find((item) => item.name === matchingItem.name)
      const interests = matchingItem.interests.filter((interest) => interest.id === id)

      existingItem
        ? existingItem.interests.push(...interests)
        : prev.push({name: matchingItem.name, interests})
    }

    return prev
  }, [] as InterestCategory[])